import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./styles.scss";
import moment from "moment";
import AppHeader from "../../components/header";
import AppConfig from "../../helpers/config";
import Slider from "react-slick";
import GoogleMapReact from "google-map-react";
// import HorizontalScroll from 'react-scroll-horizontal';
import {
    getAppConfig,
    getHotels,
    setActivityIndicator,
    setResponseType,
    setStatusCodeByGuid,
} from "../../redux/slices/appconfigSlice";
import PricePin from "../../assets/images/offer-map-pin.png";
import HoverPin from "../../assets/images/search-icon.svg";
import GeniusIcon from "../../assets/images/genius_bestemming.svg";
import FilterIcon from "../../assets/images/icons/Bold-Filter.svg";
import GeniusImage from "../../assets/images/genius-bird.png";
import { faCalendar } from "@fortawesome/pro-light-svg-icons";
import useWindowDimensions from "../../utils/getWindowDimensions";
// sidebar filters
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import { useDispatch, useSelector } from "react-redux";
import {
    setDepartureFrom,
    setFlightCabinClass,
    setNumberOfStops,
    setPriceRangeValue,
    setStarRating,
    setTravelTime,
    getSearchFilters,
} from "../../redux/slices/searchFilterSlice";
import RangeBar from "../../components/slider/RangeBar";
import { faMapMarkerAlt, faX } from "@fortawesome/pro-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Collapsible from "../../components/sections/CollapsibleFilter/CollapsibleFilter";
import { faAngleLeft, faAngleRight, faArrowLeftLong, faArrowRightLong, faMagnifyingGlass, faStar } from "@fortawesome/free-solid-svg-icons";
import TooltipSlider from "../../components/TooltipSlider";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import {
    getCurrencyBadge,
    getSearchOnlyListingParams,
    navigateToDetailPage,
} from "../../helpers/common";
import { getLoginConfig } from "../../redux/slices/loginconfigSlice";
import HotelItemMap from "../../components/HotelItem/HotelItemMap";
import HotelItemDetailMap from "../../components/HotelItem/HotelItemDetailMap";
import DesireCountryModal from "../../components/Modals/DesireCountryModal";
import DepartureFromModal from "../../components/Modals/DepartureFromModal";
import CalenderDateRangePicker from "../../components/CalenderDatePicker/CalenderDateRangePicker";
import Lottie from "lottie-react";
import GeniusJson from "../../assets/images/lottieViews/genius.json";
import BulbJson from "../../assets/images/lottieViews/bulb.json";
import { toast } from "react-toastify";
import { isTablet } from "react-device-detect";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

const MapOffersPage = () => {
    const dispatch = useDispatch();
    // guid: search correlation ID, page: pagination page, prevRoute: previous route context (for future back-navigation)
    const { guid, prevRoute, page: pageParam } = useParams();
    const calendarTriggerRef = useRef();
    const scrollRef = useRef(null);
    const offerRefs = useRef([]); // array of refs for offers
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();
    const slider = useRef(null);
    const mapChangeTimerRef = useRef(null);
    const lastMapCenterRef = useRef({ lat: null, lng: null });
    const lastCityAreaRef = useRef("");
    const geocodeRequestSeqRef = useRef(0);
    const programmaticMovementSeqRef = useRef(0);
    const hasAnimatedForCurrentLocationsRef = useRef(false);
    const previousLocationsKeyRef = useRef("");
    const userHasInteractedRef = useRef(false);
    const overlaysRef = useRef(new Map());
    const bottomOffersRef = useRef(null);
    const isFirstRun = useRef(true);
    const skipNextPageEffect = useRef(false);
    const isAnimatingRef = useRef(false);
    const searchTypeRef = useRef("Map");
    // Tracks whether the in-flight search is a coordinates-based ("find in area")
    // search. Held in a ref so it survives the async getHotels round-trip, since
    // the searchCoordinates state may be cleared before the animation effect runs.
    const isCoordinatesSearchRef = useRef(false);
    const { width } = useWindowDimensions();
    const appConfig = useSelector(getAppConfig);
    const { pagination } = appConfig;
    const visited = (pagination?.currentPage - 1) * pagination?.pageSize || 0;
    const remaining =
        Math.max(
            pagination?.totalItems - pagination?.currentPage * pagination?.pageSize,
            0
        ) || 0;
    // react-slick only re-measures on resize or a change in child count, so a new
    // offer set must remount it — otherwise it keeps the previous set's geometry.
    const offersKey = useMemo(
        () => (appConfig.offers || []).map((offer) => offer?.id).join("|"),
        [appConfig.offers]
    );
    const loginConfig = useSelector(getLoginConfig);
    const searchfilters = useSelector(getSearchFilters);
    // const selectedDesireCountry = useSelector(
    //     (state) => state.searchfilters.selectedDesireCountry
    // );

    const [showFilters, setShowFilters] = useState(false);
    const [modals, setModals] = useState({
        destination: false,
        departure: false,
    });
    const [page, setPage] = useState(Number(pageParam) || 1);
    // const [searchTrigger, setSearchTrigger] = useState(0);
    const [triggerNewSearch, setTriggerNewSearch] = useState(false);
    const toggleFilter = () => setShowFilters(!showFilters);
    const hideFilter = () => setShowFilters(false);

    const hideGreenButtonRef = useRef(searchfilters?.selectedDesireCountry?.airportCode === "001" || searchfilters?.selectedDesireCountry?.id === "00001");
    const [hotelLocations, setLocations] = useState([]);
    const [mapInstance, setMapInstance] = useState(null);
    const [mapsApi, setMapsApi] = useState(null);
    const [switchToDetailSideBar, setSwitchToDetailSideBar] = useState(false);
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [cityArea, setCityArea] = useState('');
    const [searchCoordinates, setSearchCoordinates] = useState('');
    const [geniusDestinationObject, setGeniusDestinationObject] = useState(null);
    const [performPriceExpandedSearch, setPerformPriceExpandedSearch] = useState(false);
    const { T } = useTranslationCustom();

    const [tempPrice, setTemPrice] = useState({
        low: searchfilters?.defaultPrice?.low,
        high: searchfilters?.defaultPrice?.high
    });

    // Memoize defaultProps to prevent GoogleMap warning about changing default props
    const defaultProps = useMemo(() => ({
        center: {
            lat: Number(appConfig.offers?.[0]?.location?.geoLocation?.latitude) || 52.3676,
            lng: Number(appConfig.offers?.[0]?.location?.geoLocation?.longitude) || 4.9041,
        }, // Default center (fallback to Amsterdam)
        zoom: 14,
    }), []); // Empty dependency array - only calculate once on mount

    useEffect(() => {
        if (!mapInstance || !mapsApi || !hotelLocations?.length) {
            return;
        }

        const locationsKey = hotelLocations
            .map((loc) => `${loc?.id}-${Number(loc?.lat)}-${Number(loc?.lng)}`)
            .join("|");

        // Check if locations have changed
        const locationsChanged = locationsKey !== previousLocationsKeyRef.current;

        if (locationsChanged) {
            previousLocationsKeyRef.current = locationsKey;
            hasAnimatedForCurrentLocationsRef.current = false;
            userHasInteractedRef.current = false; // Reset user interaction on new locations
            resetMapAreaState(true);
        }

        // Only auto-fit if user hasn't manually interacted with the map
        if (locationsChanged && !userHasInteractedRef.current) {
            // Filter valid locations
            const validLocations = hotelLocations.filter((loc) => {
                const lat = Number(loc?.lat);
                const lng = Number(loc?.lng);
                return !isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
            });

            // Check if animation should be triggered.
            // Skip the animation for coordinates-based ("find in area") searches.
            const isCoordinatesBasedSearch = isCoordinatesSearchRef.current;
            const shouldAnimate = !isCoordinatesBasedSearch &&
                (page !== 1 ||
                    (searchfilters?.selectedDesireCountry?.id === "00001" &&
                        searchfilters?.selectedDesireCountry?.airportCode === "001"));

            // console.log('shouldAnimate:', shouldAnimate, 'validLocations.length:', validLocations.length, 'page:', page, 'country:', searchfilters?.selectedDesireCountry);

            if (!hasAnimatedForCurrentLocationsRef.current && shouldAnimate && validLocations.length >= 3) {
                hasAnimatedForCurrentLocationsRef.current = true;
                animateClusterZoom(mapInstance, mapsApi, validLocations);
            } else {
                fitBoundsToMarkers(mapInstance, mapsApi, hotelLocations);
            }
        }

        scrollToOffer(0);
    }, [hotelLocations, mapInstance, mapsApi, searchCoordinates, searchfilters]);

    useEffect(() => {
        if (!mapInstance || !mapsApi) return undefined;

        // Track user interactions (drag, zoom)
        const dragStartListener = mapsApi.event.addListener(mapInstance, "dragstart", () => {
            userHasInteractedRef.current = true;
        });

        const zoomChangedListener = mapsApi.event.addListener(mapInstance, "zoom_changed", () => {
            // Ignore programmatic zoom changes during animation so auto-fit logic isn't broken
            if (!isAnimatingRef.current) {
                userHasInteractedRef.current = true;
            }
        });

        const idleListener = mapsApi.event.addListener(mapInstance, "idle", () => {
            // Skip geocoder calls while the cluster zoom animation is running
            if (isAnimatingRef.current) return;
            const center = mapInstance.getCenter();
            if (!center) return;
            handleMapChange({ center: { lat: center.lat(), lng: center.lng() } });
        });

        return () => {
            mapsApi.event.removeListener(dragStartListener);
            mapsApi.event.removeListener(zoomChangedListener);
            mapsApi.event.removeListener(idleListener);
        };
    }, [mapInstance, mapsApi]);

    useEffect(() => {
        if (skipNextPageEffect.current) {
            skipNextPageEffect.current = false;
            return;
        }
        if (isFirstRun.current) {
            searchTypeRef.current = "Map";
        } else {
            searchTypeRef.current = "Pagination";
        }
        handleSearchFromScratch(page, guid, false, false, searchCoordinates);
    }, [page]);

    // useEffect(() => {
    //
    //     setPage(1);
    //     setSearchTrigger((t) => t + 1); // force the search even if page = 1
    // }, [searchfilters.defaultPrice]);

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false; // skip first run
            return;
        }
        if (!appConfig.offers || appConfig.offers.length === 0) {
            setLocations([]);
            return;
        }
        const _locations = appConfig.offers.map((f) => {
            const geoLocation = f?.location?.geoLocation;
            return {
                id: f.id,
                lat: geoLocation?.latitude,
                lng: geoLocation?.longitude,
                name: f?.name,
                perPersonPrice: f?.perPersonPrice,
                selected: f.id === appConfig.offers[0]?.id,
            };
        });

        setLocations(_locations);
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: 0, behavior: "smooth" });
        }
    }, [appConfig.offers]);

    useEffect(() => {
        if (appConfig.responseType === "RealTime") {
            const runRealTimeSearch = async () => {
                navigate("/map/" + appConfig.correlationId + `/offers/${prevRoute}/1`, {
                    replace: true,
                });
                // setPage(1);
                dispatch(setResponseType(null));

                const handleRealTimeResponse = async () => {
                    const result = await Swal.fire({
                        title: T("Common:No_Matches_Under_Budget"),
                        text: appConfig.statusCodeByGuid?.warnings?.[0]?.description || T("Common:No_Matches_Under_Budget_Description"), // 'We couldn’t find any direct flights. Would you like to see results with a stopover?'
                        iconHtml: `
                            <img src=${GeniusImage}
                            alt="info"
                            style="width:80px;" />
                            `,
                        showCancelButton: true,
                        confirmButtonText: T("Buttons:Button_Yes"),
                        cancelButtonText: T("Buttons:Button_No"),
                        confirmButtonColor: "#05CE78",
                        cancelButtonColor: "#596C7F",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    // IF USER CLICKS YES → retry with full app price range
                    if (result.isConfirmed) {
                        dispatch(setPriceRangeValue({ low: AppConfig.minPrice, high: AppConfig.maxPrice }));
                        dispatch(setStatusCodeByGuid({}));
                        setPerformPriceExpandedSearch(true); // Trigger search after Redux updates
                        return;
                    }
                };

                const handleNoAvailabilityResponse = async () => {
                    await Swal.fire({
                        title: T("Common:Offers_Not_Found"),
                        text: appConfig.statusCodeByGuid?.warnings?.[0]?.description,
                        iconHtml: `
                            <img src=${GeniusImage}
                            alt="info"
                            style="width:80px;" />
                            `,
                        showCancelButton: false,
                        confirmButtonText: T("Buttons:Button_Ok"),
                        confirmButtonColor: "#05CE78",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                };

                if (appConfig.correlationId === appConfig.statusCodeByGuid?.guid && appConfig.statusCodeByGuid?.warnings?.[0]?.code === '204.02') {
                    return await handleRealTimeResponse();
                }

                if (appConfig.correlationId === appConfig.statusCodeByGuid?.guid && appConfig.statusCodeByGuid?.warnings?.[0]?.code === '204.03') {
                    return await handleNoAvailabilityResponse();
                }

                handleSearchFromScratch(1, appConfig.correlationId, false, false, searchCoordinates);
            };

            runRealTimeSearch();
        }
    }, [appConfig.responseType]);

    useEffect(() => {
        if (!isFirstRun.current && searchCoordinates && searchfilters?.departureFrom?.length && triggerNewSearch) {
            searchTypeRef.current = "Map";
            handleSearchFromScratch(1, '', false, true, searchCoordinates);
        }
    }, [triggerNewSearch, searchCoordinates, searchfilters?.departureFrom?.length]);

    useEffect(() => {
        if (performPriceExpandedSearch) {
            searchTypeRef.current = "Popup";
            handleSearchFromScratch(1, appConfig.correlationId, false, false, searchCoordinates);
            setPerformPriceExpandedSearch(false);
        }
    }, [performPriceExpandedSearch, searchfilters]);

    const handlePriceChange = ({ low, high }) => {
        setTemPrice({ low, high });
        // dispatch(setPriceRangeValue({ low, high }));
    };

    const handleSearchFromScratch = (
        page = 1,
        urlGUID = "",
        initialSearch = true,
        bigSearch = false,
        searchCoordinates = ''
    ) => {
        try {

            if (page === 1 && urlGUID === '' && searchCoordinates === '') {
                // This search is clicked by the sidebar filters button.
                if (!searchfilters.selectedDesireCountry) {
                    return toast.info(T("Toasts:Please_Choose_Package_Destination"));
                }

                if (!searchfilters?.departureFrom?.length) {
                    return toast.info(T("Toasts:Please_Choose_Departure"));
                }

                if (
                    !searchfilters.travelDate.startDate ||
                    !searchfilters.travelDate.endDate
                ) {
                    return toast.info(T("Toasts:Please_Select_Date_Range"));
                }
            }

            setShowFilters(false);
            let localGeniusDestinationObject = null;
            localGeniusDestinationObject = { ...geniusDestinationObject }
            setGeniusDestinationObject(null);
            // It is a search coodinates based map search so shouldn't add in history.
            const coordinatesFound = triggerNewSearch && searchCoordinates;
            const params = getSearchOnlyListingParams({
                guid: urlGUID,
                page: page,
                searchfilters,
                loginconfig: loginConfig,
                initialSearch,
                SearchType: searchTypeRef.current,
                bigSearch: bigSearch,
                searchCoordinates: triggerNewSearch ? searchCoordinates : '',
            });
            if (appConfig.responseType === "RealTime") {
                // A RealTime retry is a continuation of the in-flight search, not a
                // new one. searchCoordinates is already cleared here, so we must NOT
                // recompute the coordinates flag — preserve it so the second phase
                // still skips the dense-cluster animation. Only clear trigger state.
                setTriggerNewSearch(false);
                setSearchCoordinates('');
            } else {
                // New user-initiated search: (re)set the coordinates flag definitively
                // so the animation effect knows whether to skip the dense-cluster zoom.
                isCoordinatesSearchRef.current = Boolean(coordinatesFound);
            }
            dispatch(getHotels({ params, T, dispatch, navigate, shouldAddToSearchHistory: coordinatesFound ? false : true, geniusDestinationObject: localGeniusDestinationObject }));
        } catch (error) {
            console.error('MapOffers: Error in handleSearchFromScratch', error);
            dispatch(setActivityIndicator(false));
        }
    };

    const getClassFromFilledStarts = (number) => {
        if (
            number >= searchfilters.starRating?.min &&
            number <= searchfilters.starRating?.max
        ) {
            return "filled";
        } else {
            return "";
        }
    };

    function fitBoundsToMarkers(map, maps, locations) {
        // const windowWidth = window.innerWidth;
        if (!locations || locations.length === 0) return;

        const bounds = new maps.LatLngBounds();

        locations.forEach((loc) => {
            bounds.extend(new maps.LatLng(Number(loc.lat), Number(loc.lng)));
        });

        // Treat fitting all markers as programmatic movement so the idle listener
        // does not immediately reverse-geocode the map center and refill cityArea.
        const movementSeq = programmaticMovementSeqRef.current + 1;
        programmaticMovementSeqRef.current = movementSeq;
        isAnimatingRef.current = true;
        resetMapAreaState(true);
        map.fitBounds(bounds, getMapBoundsPadding());
        const clearProgrammaticMovement = () => {
            if (movementSeq === programmaticMovementSeqRef.current) {
                isAnimatingRef.current = false;
            }
        };
        maps.event.addListenerOnce(map, "idle", () => {
            clearProgrammaticMovement();
        });
        setTimeout(clearProgrammaticMovement, 1200);
    }

    function getBoundsForLocations(maps, locations) {
        if (!locations || locations.length === 0) return null;

        const bounds = new maps.LatLngBounds();
        locations.forEach((loc) => {
            bounds.extend(new maps.LatLng(Number(loc.lat), Number(loc.lng)));
        });

        return bounds;
    }

    function wait(duration) {
        return new Promise((resolve) => setTimeout(resolve, duration));
    }

    function resetMapAreaState(shouldClearCoordinates = false) {
        geocodeRequestSeqRef.current += 1;
        lastMapCenterRef.current = { lat: null, lng: null };
        lastCityAreaRef.current = "";

        if (mapChangeTimerRef.current) {
            clearTimeout(mapChangeTimerRef.current);
            mapChangeTimerRef.current = null;
        }

        setCityArea('');
        if (shouldClearCoordinates) {
            setSearchCoordinates('');
        }
    }

    function getMapBoundsPadding() {
        return { top: 90, right: 10, bottom: 270, left: 10 };
    }

    async function animateCameraInLimitedSteps(map, targetCenter, targetZoom, duration = 1800, steps = 5) {
        const startCenter = map.getCenter();
        const startZoom = Number(map.getZoom());

        if (!startCenter || !targetCenter || !Number.isFinite(startZoom) || !Number.isFinite(targetZoom)) {
            return;
        }

        const start = {
            lat: startCenter.lat(),
            lng: startCenter.lng(),
            zoom: startZoom,
        };
        const end = {
            lat: targetCenter.lat(),
            lng: targetCenter.lng(),
            zoom: targetZoom,
        };
        const lngDelta = ((((end.lng - start.lng) % 360) + 540) % 360) - 180;
        const easeInOutCubic = (progress) => (
            progress < 0.5
                ? 4 * progress * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 3) / 2
        );

        if (map.setOptions) {
            map.setOptions({ isFractionalZoomEnabled: true });
        }

        for (let step = 1; step <= steps; step += 1) {
            const progress = step / steps;
            const eased = easeInOutCubic(progress);
            const center = {
                lat: start.lat + (end.lat - start.lat) * eased,
                lng: start.lng + lngDelta * eased,
            };
            const zoom = start.zoom + (end.zoom - start.zoom) * eased;

            if (map.moveCamera) {
                map.moveCamera({ center, zoom });
            } else {
                map.setCenter(center);
                map.setZoom(zoom);
            }

            await wait(duration / steps);
        }
    }

    async function animateSlowZoomOutToAllMarkers(map, maps, locations) {
        const bounds = getBoundsForLocations(maps, locations);
        if (!bounds) return;

        const padding = getMapBoundsPadding();
        const startingZoom = Number(map.getZoom());
        const startingCenter = map.getCenter();

        map.fitBounds(bounds, padding);

        await new Promise((resolve) => {
            maps.event.addListenerOnce(map, "idle", resolve);
        });

        const targetZoom = Number(map.getZoom());
        const targetCenter = map.getCenter();

        if (!Number.isFinite(startingZoom) || !Number.isFinite(targetZoom)) {
            fitBoundsToMarkers(map, maps, locations);
            return;
        }

        if (startingCenter && map.moveCamera) {
            map.moveCamera({ center: startingCenter, zoom: startingZoom });
        } else {
            if (startingCenter) {
                map.setCenter(startingCenter);
            }
            map.setZoom(startingZoom);
        }

        await wait(120);

        // Smooth enough to feel animated, but capped to a few camera updates so
        // Google Maps does not spam viewport requests during the transition.
        await animateCameraInLimitedSteps(map, targetCenter, targetZoom, 1800, 15);
    }

    function getDistanceInMeters(pointA, pointB) {
        const toRadians = (value) => (value * Math.PI) / 180;
        const earthRadiusInMeters = 6371000;

        const latitudeA = Number(pointA.lat);
        const longitudeA = Number(pointA.lng);
        const latitudeB = Number(pointB.lat);
        const longitudeB = Number(pointB.lng);

        const deltaLatitude = toRadians(latitudeB - latitudeA);
        const deltaLongitude = toRadians(longitudeB - longitudeA);

        const a =
            Math.sin(deltaLatitude / 2) * Math.sin(deltaLatitude / 2) +
            Math.cos(toRadians(latitudeA)) *
            Math.cos(toRadians(latitudeB)) *
            Math.sin(deltaLongitude / 2) *
            Math.sin(deltaLongitude / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return earthRadiusInMeters * c;
    }

    function findDenseClusters(locations, radiusInMeters = 5000, minClusterSize = 3) {

        if (!locations || locations.length < minClusterSize) {
            return [];
        }

        const clusters = locations
            .map((centerLocation) => {
                const nearbyLocations = locations.filter((candidateLocation) => {
                    const dist = getDistanceInMeters(centerLocation, candidateLocation);
                    return dist <= radiusInMeters;
                });
                return nearbyLocations;
            })
            .filter((cluster) => cluster.length >= minClusterSize);

        return clusters;
    }

    function getDensestCluster(clusters) {
        if (!clusters || clusters.length === 0) return null;

        // Find cluster with most markers
        return clusters.reduce((densest, current) =>
            current.length > densest.length ? current : densest
        );
    }

    function fitBoundsToCluster(map, maps, cluster) {
        if (!cluster || cluster.length === 0) return;

        const bounds = new maps.LatLngBounds();
        cluster.forEach((loc) => {
            bounds.extend(new maps.LatLng(Number(loc.lat), Number(loc.lng)));
        });

        map.fitBounds(bounds, getMapBoundsPadding());
    }

    async function animateClusterZoom(map, maps, locations) {
        if (
            !locations ||
            locations.length < 3 ||
            isCoordinatesSearchRef.current ||
            searchfilters?.selectedDesireCountry?.id !== "00001" ||
            searchfilters?.selectedDesireCountry?.airportCode !== "001"
        ) {
            // Skip the dense-cluster zoom for coordinates-based searches or when
            // there are too few locations; just fit all bounds instead.
            fitBoundsToMarkers(map, maps, locations);
            return;
        }

        // Find clusters
        const clusters = findDenseClusters(locations, 5000, 2);

        // If no dense clusters found, just fit all bounds
        if (clusters.length === 0) {
            fitBoundsToMarkers(map, maps, locations);
            return;
        }

        // Get the densest cluster
        const densestCluster = getDensestCluster(clusters);

        // Only animate if cluster has reasonable size difference
        if (densestCluster.length < 2) {
            fitBoundsToMarkers(map, maps, locations);
            return;
        }

        // Step 1: Zoom into the densest cluster
        // Set flag before any programmatic map movement so event listeners
        // don't treat animation steps as user interactions or trigger geocoder calls.
        programmaticMovementSeqRef.current += 1;
        isAnimatingRef.current = true;
        try {
            fitBoundsToCluster(map, maps, densestCluster);

            // Step 2: Wait a bit and then slowly zoom out to show all locations
            await wait(4000); // pause on cluster before zooming out
            await animateSlowZoomOutToAllMarkers(map, maps, locations);
            hideGreenButtonRef.current = true;
        } finally {
            isAnimatingRef.current = false;
            if (searchTypeRef.current === "Filter" && searchfilters?.selectedDesireCountry?.airportCode === "001") {
                resetMapAreaState(true);
            }
        }
    }

    const handleOnOfferCardClick = useCallback((offer, locationId) => {
        if (isMobile || isTablet) {
            !offer?.detailsLink &&
                navigateToDetailPage(
                    offer,
                    dispatch,
                    loginConfig,
                    searchfilters,
                    navigate,
                    "hotel",
                    true,
                    false,
                    false,
                    null, // Branch data null
                )
            return;
        }

        setSwitchToDetailSideBar(true);
        setSelectedOffer(offer);

        if (locationId) {
            const offerIndex = appConfig.offers.findIndex(f => f?.id === locationId);
            if (offerIndex >= 0) {
                scrollToOffer(offerIndex);
            }
            if (slider && offerIndex >= 0) {
                slider?.current?.slickGoTo(offerIndex, true);
            }
        }
    }, [
        appConfig.offers,
        dispatch,
        isMobile,
        loginConfig,
        navigate,
        searchfilters,
        slider,
    ]);

    const handleMarkerClick = useCallback((locationId) => {
        const _offer = appConfig.offers?.find((f) => f?.id === locationId);
        if (_offer) {
            handleOnOfferCardClick(_offer, locationId);
        }
    }, [appConfig.offers, handleOnOfferCardClick]);

    useEffect(() => {
        if (!mapInstance || !mapsApi) return;

        const buildMarkerElement = (loc, isSelected, labelText) => {
            const container = document.createElement("div");
            container.className = "map-offers-marker";
            container.style.cursor = "pointer";

            if (isSelected) {
                const img = document.createElement("img");
                img.src = HoverPin;
                img.alt = "marker-green-icon";
                container.appendChild(img);
                return container;
            }

            const img = document.createElement("img");
            img.src = PricePin;
            img.alt = "marker-green-icon";
            container.appendChild(img);

            const price = document.createElement("div");
            price.className = "price-marker";
            price.textContent = labelText;
            container.appendChild(price);

            const hoverImg = document.createElement("img");
            hoverImg.className = "marker-hover-img";
            hoverImg.src = HoverPin;
            hoverImg.alt = "marker-green-icon";
            container.appendChild(hoverImg);

            return container;
        };

        const createOverlay = (loc, isSelected, labelText) => {
            const overlay = new mapsApi.OverlayView();
            overlay.position = new mapsApi.LatLng(Number(loc.lat), Number(loc.lng));
            overlay.div = null;
            overlay.onAdd = () => {
                overlay.div = buildMarkerElement(loc, isSelected, labelText);
                overlay.div.addEventListener("click", () => handleMarkerClick(loc.id));
                const panes = overlay.getPanes();
                panes.overlayMouseTarget.appendChild(overlay.div);
            };
            overlay.draw = () => {
                if (!overlay.div) return;
                const projection = overlay.getProjection();
                if (!projection) return;
                const point = projection.fromLatLngToDivPixel(overlay.position);
                if (!point) return;
                overlay.div.style.position = "absolute";
                overlay.div.style.left = `${point.x}px`;
                overlay.div.style.top = `${point.y}px`;
                overlay.div.style.transform = "translate(-50%, -100%)";
            };
            overlay.onRemove = () => {
                if (overlay.div && overlay.div.parentNode) {
                    overlay.div.parentNode.removeChild(overlay.div);
                }
                overlay.div = null;
            };
            overlay.setMap(mapInstance);
            return overlay;
        };

        const updateOverlay = (overlay, loc, isSelected, labelText) => {
            overlay.position = new mapsApi.LatLng(Number(loc.lat), Number(loc.lng));
            if (overlay.div) {
                const nextDiv = buildMarkerElement(loc, isSelected, labelText);
                nextDiv.addEventListener("click", () => handleMarkerClick(loc.id));
                overlay.div.replaceWith(nextDiv);
                overlay.div = nextDiv;
            }
            if (overlay.draw) {
                overlay.draw();
            }
        };

        const nextIds = new Set(hotelLocations.map((loc) => loc.id));

        overlaysRef.current.forEach((overlay, id) => {
            if (!nextIds.has(id)) {
                overlay.setMap(null);
                overlaysRef.current.delete(id);
            }
        });

        hotelLocations.forEach((loc) => {
            if (!loc?.lat || !loc?.lng || !loc?.id) return;

            const perPersonPrice = loc?.perPersonPrice;
            if (!perPersonPrice?.currency || perPersonPrice?.totalPrice === null || perPersonPrice?.totalPrice === undefined) {
                return;
            }

            const isSelected = selectedOffer?.id === loc.id;
            const labelText = `${getCurrencyBadge(perPersonPrice.currency)}${Number(perPersonPrice.totalPrice).toFixed(0)}`;

            const existingOverlay = overlaysRef.current.get(loc.id);
            if (existingOverlay) {
                updateOverlay(existingOverlay, loc, isSelected, labelText);
            } else {
                const overlay = createOverlay(loc, isSelected, labelText);
                overlaysRef.current.set(loc.id, overlay);
            }
        });
    }, [
        handleMarkerClick,
        hotelLocations,
        mapInstance,
        mapsApi,
        selectedOffer,
    ]);

    useEffect(() => {
        return () => {
            overlaysRef.current.forEach((overlay) => overlay.setMap(null));
            overlaysRef.current.clear();
        };
    }, []);

    const scrollToOffer = (index) => {
        offerRefs.current[index]?.scrollIntoView({
            behavior: "smooth",
            inline: "center" // aligns horizontally
        });
    };

    // Mobile responsiveness
    useEffect(() => {
        width < 767 ? setIsMobile(true) : setIsMobile(false);
    }, [width]);

    function SampleNextArrow({ onClick }) {
        return (
            slider?.current?.innerSlider?.state?.currentSlide <
            slider?.current?.innerSlider?.state?.slideCount -
            slider?.current?.innerSlider?.props?.slidesToShow && (
                // <span
                //     className="fas fa-long-arrow-alt-right slick-arrow arrow-right"
                //     onClick={onClick}
                // ></span>
                <FontAwesomeIcon icon={faArrowRightLong} className="slick-arrow arrow-right" onClick={onClick} />
            )
        );
    }

    function SamplePrevArrow({ onClick }) {
        return (
            slider?.current?.innerSlider?.state?.currentSlide > 0 && (
                // <span
                //     className="fas fa-long-arrow-alt-left slick-arrow arrow-left"
                //     onClick={onClick}
                // ></span>
                <FontAwesomeIcon icon={faArrowLeftLong} className="slick-arrow arrow-left" onClick={onClick} />
            )
        );
    }

    SampleNextArrow.propTypes = {
        onClick: PropTypes.func,
    };

    SamplePrevArrow.propTypes = {
        onClick: PropTypes.func,
    };

    const settings = {
        slidesToShow: 1,
        infinite: false,
        speed: 300,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        arrows: true,
        //    centerMode: true,
        //    variableWidth: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "0",
                },
            },
        ],
    };

    const SideBarFilters = () => {
        return (
            <div className={`sidebar-map ${switchToDetailSideBar && "d-none"} ${showFilters && 'open-filter'}`}>
                <form
                    className="collapsable-filter-wrapper"
                >
                    <div className="filter-header show-on-small-screen">
                        <div className="filter-title-area">
                            <a onClick={hideFilter} className="close-icon">
                                <FontAwesomeIcon icon={faTimes} />
                            </a>
                        </div>
                    </div>
                    <div className="collapsable-block">
                        <div className="rangeslider">
                            <RangeBar
                                lowPrice={tempPrice.low}
                                highPrice={tempPrice.high}
                                onChangePriceHandler={handlePriceChange}
                            />
                        </div>
                    </div>
                    <hr className="seperator" />

                    <div className="check-in for-large-screen">
                        <div className="icon">
                            <FontAwesomeIcon icon={faCalendar} />
                        </div>
                        <div
                            ref={calendarTriggerRef}
                            className="text"
                            onClick={() => {
                                setShowCalendar(!showCalendar);
                            }}
                        >
                            <div>
                                <h6 className="darkgray-text">{T("Filters:Check_In")}</h6>
                                <p className="no-margin">
                                    {searchfilters.travelDate.startDate
                                        ? moment(new Date(searchfilters.travelDate.startDate)).format(
                                            "MMM DD"
                                        )
                                        : T("Filters:Info_No_Date_Selected")}
                                </p>
                            </div>

                            <div>
                                <h6 className="darkgray-text">{T("Filters:Check_Out")}</h6>
                                <p className="no-margin">
                                    {searchfilters.travelDate.endDate
                                        ? moment(new Date(searchfilters.travelDate.endDate)).format("MMM DD")
                                        : T("Filters:Info_No_Date_Selected")}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="stars-range-wrapper">
                        <div className="range-bar">
                            <div className="caption">
                                <p>{T("Common:Rating")}</p>
                            </div>
                            <div className="range-container">
                                <p className="range-value lowest">
                                    {searchfilters.starRating.min || AppConfig.minStarRating}
                                </p>
                                <div className="range-slider-holder">
                                    <div className="tiles filter-star-rating">
                                        <div className={getClassFromFilledStarts(1)}>
                                            <FontAwesomeIcon icon={faStar} />
                                        </div>
                                        <div className={getClassFromFilledStarts(2)}>
                                            <FontAwesomeIcon icon={faStar} />
                                        </div>
                                        <div className={getClassFromFilledStarts(3)}>
                                            <FontAwesomeIcon icon={faStar} />
                                        </div>
                                        <div className={getClassFromFilledStarts(4)}>
                                            <FontAwesomeIcon icon={faStar} />
                                        </div>
                                        <div className={getClassFromFilledStarts(5)}>
                                            <FontAwesomeIcon icon={faStar} />
                                        </div>
                                    </div>
                                    <div className="outerslider-container">
                                        <TooltipSlider
                                            range
                                            step={1}
                                            min={AppConfig.minStarRating}
                                            max={AppConfig.maxStarRating}
                                            defaultValue={[
                                                AppConfig.minStarRating,
                                                AppConfig.maxStarRating,
                                            ]}
                                            value={[
                                                searchfilters.starRating?.min,
                                                searchfilters.starRating?.max,
                                            ]}
                                            onChange={(value) => {
                                                if (value[1] === 1) {
                                                    dispatch(setStarRating({ min: value[0], max: 2 }));
                                                    return;
                                                }
                                                dispatch(
                                                    setStarRating({ min: value[0], max: value[1] })
                                                );
                                            }}
                                            style={{ padding: 0 }}
                                            handleStyle={{
                                                backgroundColor: "#fff",
                                                borderColor: "white",
                                                width: "18px",
                                                height: "18px",
                                                marginTop: "-6px",
                                                cursor: "pointer",
                                                zIndex: 1,
                                                opacity: "100%",
                                            }}
                                            trackStyle={{
                                                backgroundColor: "rgb(5, 206, 120)",
                                            }}
                                            activeDotStyle={{
                                                borderWidth: "0px",
                                                borderColor: "white",
                                            }}
                                            dotStyle={{ height: "20px" }}
                                        />
                                    </div>
                                </div>
                                <p className="range-value highest">
                                    {searchfilters.starRating.max || AppConfig.maxStarRating}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="collapsable-block">
                        <h6 className="heading fs-14 medium">
                            {T("Filters:Destinations")}
                        </h6>

                        <div className="form-group">
                            <FontAwesomeIcon
                                icon={faMapMarkerAlt}
                                className="floating-icon"
                            />
                            <input
                                readOnly
                                type="text"
                                name="desireLocation"
                                value={
                                    searchfilters?.selectedDesireCountry?.keyword ||
                                    T("Filters:Choose_Destination")
                                }
                                onClick={() =>
                                    setModals({
                                        ...modals,
                                        destination: !modals.destination,
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="collapsable-block">
                        <h6 className="heading fs-14 medium">
                            {T("Filters:Departure_From")}
                        </h6>
                        <div className="form-group">
                            <FontAwesomeIcon
                                icon={faMapMarkerAlt}
                                className="floating-icon"
                            />
                            <input
                                readOnly
                                type="text"
                                name="desireLocation"
                                value={T("Filters:Filter_Departure_Placeholder")}
                                onClick={() =>
                                    setModals({
                                        ...modals,
                                        departure: !modals.departure,
                                    })
                                }
                            />
                        </div>
                        <ul className="loaction-tag">
                            {searchfilters.departureFrom?.map((_departure, index) => {
                                return (
                                    <li
                                        key={index}
                                        onClick={() =>
                                            dispatch(
                                                setDepartureFrom(
                                                    searchfilters.departureFrom?.filter(
                                                        (f) => f.code !== _departure.code
                                                    )
                                                )
                                            )
                                        }
                                    >
                                        {`${_departure?.code} ${_departure?.name}`} <span>x</span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <div className="collapsable-block">
                        <h6 className="heading fs-14 medium">
                            {T("Filters:Filters_Class")}
                        </h6>
                        <div className="form-group dropdown-with-checkbox">
                            <Dropdown>
                                <Dropdown.Toggle>
                                    {searchfilters.flightCabinClass || T("Filters:Filers_Choose_Class")}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {AppConfig.airlineClasses.map((airline, index) => {
                                        return (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => {
                                                    dispatch(setFlightCabinClass(airline.value));
                                                }}
                                                active={
                                                    searchfilters.flightCabinClass === airline?.value
                                                }
                                            >
                                                {airline?.text}
                                            </Dropdown.Item>
                                        );
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                    <div className="collapsable-block">
                        <Collapsible
                            title={T("Filters:Filters_Stops")}
                            _activeKey={"stops"}
                            open={true}
                            checkedItemHandler={(_item) => _item.id === searchfilters.numberOfStops}
                            handleClickEvent={(e, item) => {
                                dispatch(setNumberOfStops(item?.id));
                            }}
                            items={AppConfig.steps}
                        />
                    </div>
                    <div className="collapsable-block">
                        <Collapsible
                            title={T("Filters:Filters_Flight_Departure_Times")}
                            _activeKey={"departure-time"}
                            open={true}
                            multiple={false}
                            checkedItemHandler={(_item) => {
                                if (_item.StartTime && _item.EndTime) {
                                    return `${_item.StartTime}-${_item.EndTime}` === searchfilters?.travelTime?.departureTime;
                                } else if (_item.id === 1) {
                                    return _item.text === searchfilters?.travelTime?.departureTime;
                                }
                                return false;
                            }}
                            handleClickEvent={(e, item) => {
                                dispatch(
                                    setTravelTime({
                                        departureTime: item?.StartTime && item?.EndTime
                                            ? `${item.StartTime}-${item.EndTime}`
                                            : "Anytime",
                                        arrivalTime: searchfilters?.travelTime?.arrivalTime || null,
                                    })
                                );
                            }}
                            items={AppConfig.departureTime}
                        />
                    </div>
                    <div className="collapsable-block">
                        <Collapsible
                            title={T("Filters:Filters_Flight_Return_Times")}
                            _activeKey={"arrival-time"}
                            open={true}
                            multiple={false}
                            checkedItemHandler={(_item) => {
                                if (_item.StartTime && _item.EndTime) {
                                    return `${_item.StartTime}-${_item.EndTime}` === searchfilters?.travelTime?.arrivalTime;
                                } else if (_item.id === 1) {
                                    return _item.text === searchfilters?.travelTime?.arrivalTime;
                                }
                                return false;
                            }}

                            handleClickEvent={(e, item) => {
                                dispatch(
                                    setTravelTime({
                                        departureTime:
                                            searchfilters?.travelTime?.departureTime || null,
                                        arrivalTime: item?.StartTime && item?.EndTime
                                            ? `${item.StartTime}-${item.EndTime}`
                                            : "Anytime",
                                    })
                                );
                            }}
                            items={AppConfig.arrivalTime}
                        />
                    </div>

                    <div className="filters-sidebar-btn">
                        <a
                            className="apply-filter-btn"
                            onClick={async () => {
                                skipNextPageEffect.current = true;
                                dispatch(setPriceRangeValue({ low: tempPrice.low, high: tempPrice.high }));
                                setPage(1);
                                setTriggerNewSearch(false);
                                resetMapAreaState(true);
                                searchTypeRef.current = "Filter";
                                handleSearchFromScratch(1, "", false, true, '');
                            }}
                        >
                            {T("Buttons:Search")}
                        </a>
                    </div>
                </form>
            </div>
        );
    };

    const handleMapChange = ({ center }) => {
        if (!mapsApi || !center) return;


        const last = lastMapCenterRef.current;
        const latChanged = last.lat === null || Math.abs(center.lat - last.lat) > 0.0005;
        const lngChanged = last.lng === null || Math.abs(center.lng - last.lng) > 0.0005;

        if (!latChanged && !lngChanged) return;

        lastMapCenterRef.current = { lat: center.lat, lng: center.lng };

        if (mapChangeTimerRef.current) {
            clearTimeout(mapChangeTimerRef.current);
        }

        const requestSeq = geocodeRequestSeqRef.current + 1;
        geocodeRequestSeqRef.current = requestSeq;

        mapChangeTimerRef.current = setTimeout(() => {
            if (requestSeq !== geocodeRequestSeqRef.current || isAnimatingRef.current) {
                return;
            }

            const geocoder = new mapsApi.Geocoder();
            const latlng = { lat: center.lat, lng: center.lng };

            geocoder.geocode({ location: latlng }, (results, status) => {
                if (requestSeq !== geocodeRequestSeqRef.current || isAnimatingRef.current) {
                    return;
                }

                const currentCenter = mapInstance?.getCenter?.();
                if (currentCenter) {
                    const centerMoved =
                        Math.abs(currentCenter.lat() - center.lat) > 0.0005 ||
                        Math.abs(currentCenter.lng() - center.lng) > 0.0005;

                    if (centerMoved) {
                        return;
                    }
                }

                if (status === "OK" && results[0]) {
                    const location = results[0].geometry.location;
                    const closestLat = location.lat();
                    const closestLng = location.lng();
                    const nextSearchCoordinates = `|${closestLat},${closestLng}|`;

                    if (nextSearchCoordinates !== searchCoordinates) {
                        setSearchCoordinates(nextSearchCoordinates);
                    }

                    // Find the most relevant city/area name
                    const addressComponents = results[0].address_components;
                    const cityComponent =
                        addressComponents.find((c) => c.types.includes("locality")) ||
                        addressComponents.find((c) => c.types.includes("administrative_area_level_2")) ||
                        addressComponents.find((c) => c.types.includes("administrative_area_level_1"));

                    if (cityComponent) {
                        const nextCity = cityComponent.long_name;
                        // if (searchTypeRef.current === "Filter" && searchfilters?.selectedDesireCountry?.airportCode === "001") return;

                        if (nextCity !== lastCityAreaRef.current && hideGreenButtonRef.current === false) {
                            lastCityAreaRef.current = nextCity;
                            setCityArea(nextCity);
                        } else {
                            hideGreenButtonRef.current = false; // reset the anywhere search ref after the first map move to allow future updates to city area when user moves the map again   
                        }
                    }
                } else {
                    console.error("Geocoder failed:", status);
                }
            });
        }, 300);
    };

    const handleSearchAreaClick = async () => {
        try {
            // dispatch(setActivityIndicator(true));
            // const params = {
            //     searchTerm: cityArea,
            //     Locale: loginConfig?.locale?.code,
            // };
            // const response = await SearchCountries(params);
            // const locations = response?.locations;

            // const result = getBestMatch(params.searchTerm, locations);
            // console.log('Matched location:', result);
            // setGeniusDestinationObject(result);
            // dispatch(setActivityIndicator(false));

            setTimeout(() => {
                setTriggerNewSearch(true);
            }, 500);

        } catch (error) {
            console.error(error, 'in search area get offers');
            // toast.error(T('Toasts:Toast_Description_Server_Error_Message'));
            // dispatch(setActivityIndicator(false));
        }
    };

    const handleArrowClick = (direction) => {
        const scrollContainer = scrollRef.current;

        if (!scrollContainer) return;

        const scrollAmount = 350; // adjust for how far each click should scroll

        if (direction === "left") {
            scrollContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        } else if (direction === "right") {
            scrollContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
    };

    return (
        <div className="main-wrapper flight-page map-page">
            <CalenderDateRangePicker
                show={showCalendar}
                triggerRef={calendarTriggerRef}
                onSelect={() => setShowCalendar(false)}
                onClose={() => setShowCalendar(false)}
            />
            <main className="body-wrapper">
                <AppHeader offersMap={true} />
                <div className="map-page-wrapper">
                    <div className="map-wrapper">
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: AppConfig.googleMapAPIKey }}
                            defaultCenter={defaultProps.center}
                            defaultZoom={defaultProps.zoom}
                            yesIWantToUseGoogleMapApiInternals
                            onGoogleApiLoaded={({ map, maps }) => {
                                setMapInstance(map);
                                setMapsApi(maps);
                                // Initial load handled by useEffect with proper condition checks
                            }}
                            options={{
                                fullscreenControl: false,
                            }}
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                        >
                        </GoogleMapReact>
                        <div className="bottom-offers-container hide-on-small-screen">
                            {false && cityArea &&
                                <div className={'city-area-txt'} onClick={handleSearchAreaClick}>
                                    <span>
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                        {/* Find in {cityArea} */}
                                        {" "}{T("Buttons:Find_In_Area")}
                                    </span>
                                </div>}
                            {(!switchToDetailSideBar && !showFilters) ?
                                <img className="genius-icon" src={GeniusIcon} /> : null}
                            {appConfig.offers?.length ? <div className="bottom-offers" ref={bottomOffersRef}>
                                <div className="mapoffers-arrow left" onClick={() => handleArrowClick('left')}>
                                    <FontAwesomeIcon icon={faAngleLeft} />
                                </div>
                                {/* <HorizontalScroll
                                    reverseScroll={true} // set to true if you want natural trackpad scroll
                                    config={{stiffness: 160, damping: 20}} // smoothness
                                    className={!switchToDetailSideBar && !showFilters ? "" : "sidebarshown"}
                                > */}
                                <div ref={scrollRef} className="bottom-offers-inner">
                                    {visited > 0 && (
                                        <div
                                            className="revisit-box"
                                            onClick={() => {
                                                searchTypeRef.current = "Pagination";
                                                setPage(page - 1);
                                                navigate("/map/" + appConfig.correlationId + `/offers/${prevRoute}/${page - 1}`, {
                                                    replace: true,
                                                });
                                            }}
                                        >
                                            {/* <div className="revisit-txt">{T('Filters:Map_Offer_Revisit')}</div> */}
                                            <div className="revisit-no">{visited}</div>
                                            <div
                                                className="p-locations">{T('Filters:Map_Offer_Previous_Locations')}</div>
                                        </div>
                                    )}
                                    {appConfig.offers?.map((offer, index) => {
                                        return (
                                            <div
                                                key={index}
                                                ref={(el) => (offerRefs.current[index] = el)}
                                                onClick={() => handleOnOfferCardClick(offer, null)}
                                            >
                                                <HotelItemMap
                                                    offer={offer}
                                                    isDesktop={false}
                                                    isMobile={false}
                                                    isSelected={selectedOffer?.id === offer?.id}
                                                />
                                            </div>
                                        );
                                    })}
                                    {remaining > 0 && (
                                        <div
                                            className="revisit-box green-box"
                                            onClick={() => {
                                                searchTypeRef.current = "Pagination";
                                                setPage(page + 1);
                                                navigate("/map/" + appConfig.correlationId + `/offers/${prevRoute}/${page + 1}`, {
                                                    replace: true,
                                                });
                                            }}
                                        >
                                            {/* <div className="revisit-txt">{T('Filters:Map_Offer_Explore')}</div> */}
                                            <div className="revisit-no">{remaining}</div>
                                            <div
                                                className="p-locations">{T('Filters:Map_Offer_Further_Locations')}</div>
                                        </div>
                                    )}
                                </div>
                                {/* </HorizontalScroll> */}
                                <div className="mapoffers-arrow right" onClick={() => handleArrowClick('right')}>
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </div>
                            </div> : null}
                        </div>

                        <div className="mobile-only bottom-offers-container">
                            {false && cityArea &&
                                <div className={'city-area-txt'} onClick={handleSearchAreaClick}>
                                    <span>
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                        {/* Find in {cityArea} */}
                                        {" "}{T("Buttons:Find_In_Area")}
                                    </span>
                                </div>}
                            {appConfig.offers?.length ? (
                                <div className="flight-slider bottom-offers">
                                    <Slider
                                        ref={slider}
                                        key={offersKey}
                                        {...settings}
                                        initialSlide={visited > 0 ? 1 : 0}
                                    >
                                        {visited > 0 && (
                                            <div
                                                className="revisit-box"
                                                onClick={() => {
                                                    searchTypeRef.current = "Pagination";
                                                    setPage(page - 1);
                                                    navigate("/map/" + appConfig.correlationId + `/offers/${prevRoute}/${page - 1}`, {
                                                        replace: true,
                                                    });
                                                }}
                                            >
                                                {/* <div className="revisit-txt">{T('Filters:Map_Offer_Revisit')}</div> */}
                                                <div className="revisit-no">{visited}</div>
                                                <div
                                                    className="p-locations">{T('Filters:Map_Offer_Previous_Locations')}</div>
                                            </div>
                                        )}
                                        {appConfig.offers?.map((offer, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() => handleOnOfferCardClick(offer)}
                                                >
                                                    <HotelItemMap
                                                        offer={offer}
                                                        isDesktop={false}
                                                        isMobile={false}
                                                        isSelected={selectedOffer?.id === offer?.id}
                                                    />
                                                </div>
                                            );
                                        })}
                                        {remaining > 0 && (
                                            <div
                                                className="revisit-box green-box"
                                                onClick={() => {
                                                    searchTypeRef.current = "Pagination";
                                                    setPage(page + 1);
                                                    navigate("/map/" + appConfig.correlationId + `/offers/${prevRoute}/${page + 1}`, {
                                                        replace: true,
                                                    });
                                                }}
                                            >
                                                {/* <div className="revisit-txt">{T('Filters:Map_Offer_Explore')}</div> */}
                                                <div className="revisit-no">{remaining}</div>
                                                <div
                                                    className="p-locations">{T('Filters:Map_Offer_Further_Locations')}</div>
                                            </div>
                                        )}
                                    </Slider>
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="filter-mob-wrapper">
                        <div className="filter-toggles back-btn">
                            {prevRoute === 'chat' ? (
                                <a className="animated-back-btn" onClick={() => navigate(-1)}>
                                    <Lottie animationData={GeniusJson} loop={true} className='genius-animation' />
                                    <Lottie animationData={BulbJson} loop={true} className='bulb-animation' />
                                    <span>{T("Buttons:Button_Chat_Ai")}</span>
                                </a>
                            ) :
                                <a onClick={() => {
                                    navigate(
                                        "/search/" +
                                        guid +
                                        "/query?page=1&locale=" +
                                        loginConfig.locale.code +
                                        "&currency=" +
                                        loginConfig?.currency?.code, { replace: true }
                                    );
                                }}>{"< " + T("Buttons:Back")}</a>
                            }
                        </div>

                        <div className="filter-toggles">
                            <a onClick={toggleFilter}>
                                {showFilters ? <FontAwesomeIcon
                                    icon={faX}
                                    className="close-icon"
                                /> :
                                    <img src={FilterIcon} alt={"filter-icon"} />}
                                {T("Filters:Filters_Text")}
                            </a>
                        </div>
                    </div>

                    {switchToDetailSideBar && (
                        <div className="hotel-details-sidebar">
                            <HotelItemDetailMap
                                offer={selectedOffer}
                                index={appConfig.offers.findIndex(f => f?.id === selectedOffer?.id)}
                                handlerOnBack={() => setSwitchToDetailSideBar(false)}
                            />
                        </div>
                    )}

                    <SideBarFilters />
                </div>

                <DesireCountryModal
                    show={modals.destination}
                    onHide={() => setModals({ ...modals, destination: false })}
                />
                <DepartureFromModal
                    show={modals.departure}
                    onHide={() => setModals({ ...modals, departure: false })}
                    onApplyButtonHandler={(values) => dispatch(setDepartureFrom(values))}
                />
            </main>
        </div>
    );
};

export default MapOffersPage;
